'use strict';

require('./wishlistGlobalModule').init();
